import { BezierEdge, EdgeLabelRenderer, StraightEdge } from "reactflow";
import DeleteIcon from "@mui/icons-material/Delete";

// ✅ Custom Edge with Delete Button
const CustomEdge = ({ id, sourceX, sourceY, targetX, targetY, deleteEdge }) => {
  const edgeCenterX = (sourceX + targetX) / 2;
  const edgeCenterY = (sourceY + targetY) / 2;

  // 📌 Choose between Straight or Curved Edges
  const isHorizontal = Math.abs(sourceX - targetX) > Math.abs(sourceY - targetY);
  const EdgeComponent = isHorizontal ? BezierEdge : StraightEdge;

  return (
    <>
      <EdgeComponent
        id={id}
        sourceX={sourceX}
        sourceY={sourceY}
        targetX={targetX}
        targetY={targetY}
        stroke="black"
        strokeWidth={2}
      />

      {/* ✅ Delete Button for Edge */}
      <EdgeLabelRenderer>
        <div
          className="absolute bg-white shadow-md rounded-full"
          style={{
            left: edgeCenterX,
            top: edgeCenterY,
            transform: "translate(-50%, -50%)",
            zIndex: 10,
            pointerEvents: "all",
          }}
        >
          <button
            onClick={() => deleteEdge(id)}
            className="bg-red-600 text-white rounded-full w-6 h-6 text-xs flex items-center justify-center"
          >
            <DeleteIcon />
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default CustomEdge;
